var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 200,
    viewBox: "0 0 640.011 512.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image-slash-regular",
    d: "M38.8,5.1A24.005,24.005,0,0,0,9.2,42.9l592,464a24.005,24.005,0,0,0,29.6-37.8l-55.5-43.5a60.262,60.262,0,0,0,.7-9.6V96a64.059,64.059,0,0,0-64-64H128A63.7,63.7,0,0,0,89.5,44.9ZM134.4,80H512a16.047,16.047,0,0,1,16,16V388.5l-53.4-41.9L387,233.3a24.059,24.059,0,0,0-38,0l-7.2,9.3L256,175.3a48.126,48.126,0,0,0-58.8-46.1Zm353,400L282.9,318.9,266,340.7,235.5,298a23.943,23.943,0,0,0-39,.1l-80,112-4.5,6.3V184.2L64,146.4V416a64.059,64.059,0,0,0,64,64Z",
    transform: "translate(0.00 0.00)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.6636235fa508b1dbea0a0de733adabff.svg";
export { ForwardRef as ReactComponent };